import { Box, Button } from "@mui/material";

const FiltrosGrupoBotoes = ({ opcoes, ativo, onSelecionar }) => (
  <Box display="flex" gap={1}>
    {opcoes.map((opcao) => {
      const selecionado = ativo(opcao);
      return (
        <Button
          key={opcao.value}
          onClick={() => onSelecionar(opcao)}
          variant={selecionado ? "contained" : "outlined"}
          disableElevation
          fullWidth
          sx={{
            textTransform: "none",
            fontWeight: selecionado ? 700 : 400,
            whiteSpace: "nowrap",
            borderRadius: 1,
            py: 1,
            ...(!selecionado && {
              color: "text.secondary",
              borderColor: "divider",
            }),
          }}
        >
          {opcao.label}
        </Button>
      );
    })}
  </Box>
);

export default FiltrosGrupoBotoes;
